/* eslint-disable react/no-danger */
import { gettext } from '@eventbrite/i18n';
import { Button, Typography } from '@eventbrite/marmalade';
import React from 'react';
import './pricingAndPackagingHeroNew.scss';

export const PricingAndPackagingHero: React.FC = () => (
    <div className="pricing-and-packaging-hero">
        <Typography variant="heading-lg" className="heading">
            {gettext('Flexible plans that grow with you')}
        </Typography>
        <Typography
            as="p"
            color="#39364F"
            variant="body-lg"
            className="subtext"
        >
            {gettext(
                'Create your event on the world’s largest and most trusted events marketplace. We’ve got everything you need to sell tickets, manage your events, and attract new attendees all in one place.',
            )}
        </Typography>
        <Button
            onClick={() => {
                window.location.href =
                    '/signin/signup/?referrer=%2Fmanage%2Fevents%2Fcreate%2F';
            }}
            size="responsive"
            variant="secondary"
            className="ctaButton"
        >
            {gettext('Get started for free')}
        </Button>
    </div>
);

export default PricingAndPackagingHero;
